<!-- Transparent by design: NO sky rect. The LINE color skin (a flat pink) is
     the sky; this SVG only carries the petals/blossoms/sparkles that float over
     it, so the wallpaper can never show a seam when LINE centers/cuts it. -->
<svg [attr.viewBox]="'0 0 ' + W + ' ' + H" preserveAspectRatio="xMidYMid slice"
     xmlns="http://www.w3.org/2000/svg">

  <!-- Aurora: a curtain built from many thin rays, then torn up by fractal
       noise so nothing in it reads as a drawn outline. -->
  <defs *ngIf="design === 'aurora'">
    <filter [attr.id]="uid + '-soft'" x="-25%" y="-25%" width="150%" height="150%">
      <feGaussianBlur stdDeviation="16"></feGaussianBlur>
    </filter>
  </defs>

  <g *ngIf="design === 'aurora'">
    <circle *ngFor="let s of stars" [attr.cx]="s.cx" [attr.cy]="s.cy" [attr.r]="s.r"
            fill="#FFFFFF" [attr.opacity]="s.o"></circle>
    <g [attr.filter]="'url(#' + uid + '-soft)'">
      <path *ngFor="let c of curtains; let i = index" [attr.d]="c.d"
            [attr.fill]="curtainStops[i].flat" [attr.opacity]="c.o"></path>
    </g>
  </g>

  <!-- Etna: EMBERS as light rather than as shapes.
       Two layers per spark — a blurred halo and a small sharp core — because that
       is what a glowing point looks like and it is the one drawing of heat that has
       no silhouette to be mistaken for something else. Five subjects with hard
       edges were tried on this wallpaper first (a star, a teardrop, a bare cone, a
       cone with puffs, a cone with a ribbon plume) and every one of them read as
       some other object; a soft glow cannot, because it is not a picture of a
       thing. -->
  <defs *ngIf="design === 'etna'">
    <filter [attr.id]="uid + '-glow'" x="-70%" y="-70%" width="240%" height="240%">
      <feGaussianBlur stdDeviation="13"></feGaussianBlur>
    </filter>
  </defs>
  <g *ngIf="design === 'etna'">
    <!-- the haloes, all of them through ONE filter: a blur per element is a blur
         pass per element, and this asset renders in a headless capture. -->
    <g [attr.filter]="'url(#' + uid + '-glow)'">
      <circle *ngFor="let e of embers" [attr.cx]="e.cx" [attr.cy]="e.cy"
              [attr.r]="e.halo" [attr.fill]="e.fill" [attr.opacity]="e.ho"></circle>
    </g>
    <!-- the cores, unblurred and much smaller. Without them the field is fog;
         with them every glow has something IN it, which is what the eye reads as
         a spark rather than as a smudge. -->
    <circle *ngFor="let e of embers" [attr.cx]="e.cx" [attr.cy]="e.cy"
            [attr.r]="e.core" [attr.fill]="e.coreFill" [attr.opacity]="e.co"></circle>
  </g>

  <!-- petals (Sakura) / twinkles (Tokyo) / clouds (Everest) over the flat skin.
       A grain with its own `sw` is an OUTLINE, everything else fills. -->
  <path *ngFor="let p of petals" [attr.d]="p.d || shapeD" [attr.transform]="p.transform"
        [attr.fill]="p.sw ? 'none' : p.fill"
        [attr.stroke]="p.sw ? p.fill : null"
        [attr.stroke-width]="p.sw || null"
        [attr.opacity]="p.o"></path>
</svg>
